export const ENGLISH_IQ_SESSION_STORAGE_KEY = 'cm_english_iq_session_v1';
